<template>
  <!-- only render component for authenticated users -->
  <div v-if="isReady && canShowNotice">
    <!-- to avoid false positives, only render the notice when the performance state is available -->
    <div id="performance-notice" v-if="performingState && !performingState.collectable">
      <div class="performance-notice-container">
        <notice-bar :title="$t('non_performing_company_status_title')" type="warning">
          {{ $t('non_performing_company_status_summary') }}
          <b
            ><a @click="trackCTA" target="_blank" :href="payNowURL">{{ $t('pay_now_action') }}<i class="icon icon-ic-payment"></i></a
          ></b>
        </notice-bar>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import NoticeBar from '@/components/shared/notice-bar/NoticeBar.vue';
import { AppConfig } from '@/data/country.config';
import { trackEvent } from '@/utils/gtm';
import { mapState } from 'vuex';
import { AppState } from '@/store/app/app.store';
import { RentalState } from '@/pages/rentals/rentals.model';
import { defineComponent } from 'vue';

const ALLOWED_LEGAL_ENTITIES = [
  AppConfig.DE.legalEntityId,
  AppConfig.ES.legalEntityId,
  AppConfig.NL.legalEntityId,
  AppConfig.FR.legalEntityId,
  AppConfig.AT.legalEntityId,
  AppConfig.IT.legalEntityId,
];

export default defineComponent({
  name: 'PerformanceNotice',
  components: {
    NoticeBar,
  },

  computed: {
    ...mapState('rentals', {
      performingState: (state) => (state as RentalState).performingState,
    }),

    ...mapState('app', {
      language: (state) => (state as AppState).activeLanguage,
    }),

    isReady() {
      const {
        app: { appReady },
        users: { isLoggedIn },
      } = this.$store.state;

      return appReady && isLoggedIn;
    },

    canShowNotice() {
      const {
        companies: { company },
      } = this.$store.state;

      return ALLOWED_LEGAL_ENTITIES.indexOf(company.legalEntityId) > -1;
    },

    payNowURL() {
      return `/billing/business/open-items?context=B2B&lang=${this.language}`;
    },
  },

  created() {
    trackEvent(
      'performance_notice_shown',
      {
        event_label: 'performance_notice',
      },
      this.$store,
    );
  },

  methods: {
    trackCTA() {
      trackEvent(
        'performance_notice_click',
        {
          event_label: 'performance_notice',
        },
        this.$store,
      );
    },
  },
});
</script>
<style src="./performance-notice.component.scss" lang="scss" scoped></style>
